import React, { Component } from 'react';
import HeaderAreaCheckout from './desktopHeaderAreaCheckout';
import TicketsPage from './desktopTicketsPage';
import DetailsPage from './desktopDetailsPage';
import PreviewCoupons from './desktopPreviewCoupons';
import PaymentScreen from './desktopPaymentScreen';
import ConfirmationScreen from './desktopConfirmationScreen';

class FullAreaCheckout extends Component {
  
  constructor(props) {
    super(props);
    var env_prod = 1;
    var sandbox_url_creator = "";
    if(env_prod === 1){
      sandbox_url_creator = "";
    }else{
      sandbox_url_creator = "-sandbox";
    }
    this.main_page_handler_tickets = this.main_page_handler_tickets.bind(this);
    this.main_page_handler_details = this.main_page_handler_details.bind(this);
    this.main_page_handler_header = this.main_page_handler_header.bind(this);
    this.main_page_handler_preview = this.main_page_handler_preview.bind(this);
    this.main_page_handler_free_confirmation = this.main_page_handler_free_confirmation.bind(this);
    this.main_page_handler_simpl = this.main_page_handler_simpl.bind(this);

    /* New implementation of URL params for old browser support as well */
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      
    var event_perma = query_string.event_name;

    var order_id_url = query_string.order_id;
    var status_id_url = query_string.status_id;
    var utm_source = query_string.source;
    var utm_medium = query_string.medium;
    var utm_campaign = query_string.campaign;
    var module_city = query_string.city;
    var paypal_id_url = query_string.PayerID;
    var token_valid = 1; //making token valid by default

    var ticket_token = query_string.ticket_token;
    var validity = query_string.validity;

    //alert(ticket_token);

    /* //Commenting old implementation
    var url_string = window.location.href;
    var url = new URL(url_string);

    var event_perma = url.searchParams.get("event_name");

    var order_id_url = url.searchParams.get("order_id");
    var status_id_url = url.searchParams.get("status_id");
    var utm_source = url.searchParams.get("source");
    var utm_medium = url.searchParams.get("medium");
    var utm_campaign = url.searchParams.get("campaign");
    var module_city = url.searchParams.get("city");
    */
    var city = "bangalore";
    if(module_city){
      city = module_city;
    }

    var source = "0";
    var medium = "0";
    var campaign = "0";

    if(utm_source){
      source = utm_source;
    }
    if(utm_medium){
      medium = utm_medium;
    }
    if(utm_campaign){
      campaign = utm_campaign;
    }

    var page_num = 1;
    var order_id = "0";
    var status_id = 0;
    var paypal_id = "0"

    //var ticket_token = "";
    var access_token = "0";



    if(order_id_url && status_id_url){
      page_num = 6;
      order_id = order_id_url;
      status_id = status_id_url;
      paypal_id = paypal_id_url;
    }else{ //Cookies not needed for confirmation page

      //ticket_token = ""; //this is for test
      
      //Getting Cookie now
      /*var validity = "";
      var name1 = "validity=";
      var ca1 = document.cookie.split(';');
      for(var i1 = 0; i1 < ca1.length; i1++) {
          var c1 = ca1[i1];
          while (c1.charAt(0) === ' ') {
              c1 = c1.substring(1);
          }
          if (c1.indexOf(name1) === 0) {
              validity = c1.substring(name1.length, c1.length);
          }
      }*/
      //validity = 1; //this is for test
      if (validity == null){
        token_valid = 0; //making token invalid
        //alert("Your ticket token is not available. The page will refresh again.");
        window.location = "https://highape.com/tickets?url=https://tickets"+sandbox_url_creator+".highape.com/?event_name="+event_perma+"&city="+city+"&source="+source+"&medium="+medium+"&campaign="+campaign;
      }else{
        validity = validity/1000; //in seconds
        var ts = Math.round((new Date()).getTime() / 1000); //current timestamp in seconds
        //console.log(validity);
        //console.log(ts);
        var ts_to_be_greater_than = validity - ts; //keeping that difference should be greater than 1 minute
        //ts_to_be_greater_than = 550; //this is for test
        if(ts_to_be_greater_than>540){ //now finding ticket_token
          var name2 = "ticket_token=";
          var name3 = "web_user_token=";
          var ca2 = document.cookie.split(';');
          for(var i2 = 0; i2 < ca2.length; i2++) {
              var c2 = ca2[i2];
              while (c2.charAt(0) === ' ') {
                  c2 = c2.substring(1);
              }
             /* if (c2.indexOf(name2) === 0) {
                  ticket_token = c2.substring(name2.length, c2.length);
              }*/
              if (c2.indexOf(name3) === 0) {
                  access_token = c2.substring(name3.length, c2.length);
              }
          }
        }else{
          token_valid = 0; //making token invalid
          //alert("Your ticket token expired. The page will refresh again.");
          window.location = "https://highape.com/tickets?url=https://tickets"+sandbox_url_creator+".highape.com/?event_name="+event_perma+"&city="+city+"&source="+source+"&medium="+medium+"&campaign="+campaign;
        }
      }
     // alert(access_token);
     
    }

    //Cookie thing done

    var lat = 0;
    var lng = 0;

    //Geolocation for getting lat lng of user, not working properly right now

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
       // this.setState({
          lat = position.coords.latitude;
          lng = position.coords.longitude;
       // });
       //alert(position.coords.latitude);
      });
    } else {
        //alert("Geolocation is not supported by this browser.");
    }

    this.state = {
      sandbox_url_creator: sandbox_url_creator,
      module_id: 0,
      event_perma: event_perma,
      page_num: page_num,
      order_id: order_id,
      status_id: status_id,
      paypal_id: paypal_id,
      tickets_selected: [],
      special_note: "",
      total_amount: 0,
      source: source,
      medium: medium,
      campaign: campaign,
      city: city,
      lat: lat,
      lng: lng,
      ticket_token: ticket_token,
      access_token: access_token,
      token_valid: token_valid
    };
    
  }

  componentWillMount(){
  }

  main_page_handler_header(page_number) {
    this.setState({
        page_num: page_number
    });
  }

  main_page_handler_tickets(page_number, module_id, order_id, event_name, event_date, event_image, event_venue_name, event_locality, event_city, event_currency, event_currency_icon, special_note, event_tc, ticket_offer_prev_page, occurrence_date) {
    this.setState({
        module_id: module_id,
        page_num: page_number,
        order_id: order_id,
        event_name: event_name,
        event_date: event_date,
        event_image: event_image,
        event_venue_name: event_venue_name,
        event_locality: event_locality,
        event_city: event_city,
        event_currency: event_currency,
        event_currency_icon: event_currency_icon,
        special_note: special_note,
        tickets_selected: ticket_offer_prev_page,
        event_tc: event_tc,
        occurrence_date: occurrence_date
    });
  }

  main_page_handler_details(page_number, user_email, user_phone) {
    this.setState({
        page_num: page_number,
        user_email: user_email,
        user_phone: user_phone
    });
  }

  main_page_handler_preview(page_number, total_amount) {
    if(total_amount===0){
      window.location = "https://tickets"+this.state.sandbox_url_creator+".highape.com?order_id="+this.state.order_id+"&status_id=21";
    }else{
      if(total_amount>0){
        this.setState({
            page_num: page_number,
            total_amount: total_amount
        });
      }
    }
    //alert(total_amount);
  }

  main_page_handler_free_confirmation(page_number){
    window.location = "https://tickets"+this.state.sandbox_url_creator+".highape.com?order_id="+this.state.order_id+"&status_id=21"; //adding this only as a fallback for now as redirection is taking place already above, remove it later
  }

  main_page_handler_simpl(){
    window.location = "https://tickets"+this.state.sandbox_url_creator+".highape.com?order_id="+this.state.order_id+"&status_id=21";
  }

//5 can be juspay screen when moving to javascript integration so skipping page 5 for now

  render() {
    if(this.state.token_valid === 1){

      let name_of_ticket_class = "";
      let name_of_ticket_btn_class = "";
      if(this.state.page_num===1){
      	name_of_ticket_class="App mobBody mobTickets col-sm-4 col-sm-offset-4 col-xs-12";
        name_of_ticket_btn_class="col-sm-4 col-xs-12 mobBody continue_right_fixed";
      }else{
      	name_of_ticket_class="App col-sm-4 col-sm-offset-4 col-xs-12 hidden";
        name_of_ticket_btn_class="col-sm-4 col-xs-12 mobBody continue_right_fixed hidden";
      }

      let name_of_header_class = "";
      if(this.state.page_num>3){
        name_of_header_class="desktopHeader col-sm-12 col-xs-12 hidden";
      }else{
        name_of_header_class="desktopHeader col-sm-12 col-xs-12";
      }
      
      let name_of_detail_class = "";
      let name_of_detail_btn_class = "";
      if(this.state.page_num===2){
        name_of_detail_class="App mobBody mobDetails col-sm-4 col-sm-offset-4 col-xs-12";
        name_of_detail_btn_class="col-sm-4 col-xs-12 mobBody";
      }else{
        name_of_detail_class="App col-sm-4 col-sm-offset-4 col-xs-12 hidden";
        name_of_detail_btn_class="col-sm-4 col-xs-12 mobBody hidden";
      }
      
      let name_of_preview_coupon_class = "";
      let name_of_preview_btn_class = "";
      if(this.state.page_num===3){
        name_of_preview_coupon_class = "App mobBody mobPreview col-sm-4 col-sm-offset-4 col-xs-12";
        name_of_preview_btn_class = "col-sm-4 col-xs-12 mobBody continue_right_fixed coupon_page_right";
      }else{
        name_of_preview_coupon_class = "App mobBody mobPreview col-sm-4 col-sm-offset-4 col-xs-12 hidden";
        name_of_preview_btn_class = "col-sm-4 col-xs-12 mobBody continue_right_fixed hidden";
      }
      
      
      let name_of_payment_screen_class = "App paymentScreen col-sm-12 col-xs-12";
      let name_of_confirmation_class = "App col-sm-4 col-sm-offset-4 col-xs-12";
      
      if(this.state.page_num<5){
          return (
          <div key="first_full_page" id="first_full_page" className="full_page">
            <HeaderAreaCheckout name_of_class={name_of_header_class} order_id={this.state.order_id} page_num={this.state.page_num} event_perma={this.state.event_perma} city={this.state.city} main_page_change={this.main_page_handler_header}/>
            <TicketsPage sandbox_url_creator={this.state.sandbox_url_creator} name_of_class={name_of_ticket_class} name_of_ticket_btn_class={name_of_ticket_btn_class} access_token="0" ticket_token={this.state.ticket_token} event_perma={this.state.event_perma} page_number={this.state.page_num} order_id={this.state.order_id} module_id={this.state.module_id} city={this.state.city}  source={this.state.source} medium={this.state.medium} campaign={this.state.campaign} lat={this.state.lat} lng ={this.state.lng} main_page_change={this.main_page_handler_tickets}/>
            <DetailsPage sandbox_url_creator={this.state.sandbox_url_creator} name_of_class={name_of_detail_class} name_of_detail_btn_class={name_of_detail_btn_class} access_token={this.state.access_token} ticket_token={this.state.ticket_token} page_number={this.state.page_num} order_id={this.state.order_id} main_page_change={this.main_page_handler_details} />
            
            {(() => {
                switch (this.state.page_num) {
                  case 3:  return <PreviewCoupons sandbox_url_creator={this.state.sandbox_url_creator} name_of_class={name_of_preview_coupon_class} name_of_preview_btn_class={name_of_preview_btn_class} access_token="0" ticket_token={this.state.ticket_token} module_id={this.state.module_id} order_id={this.state.order_id} event_name={this.state.event_name} event_date={this.state.event_date} event_image={this.state.event_image} event_venue_name={this.state.event_venue_name} event_locality={this.state.event_locality} event_city={this.state.event_city} event_currency={this.state.event_currency} event_currency_icon={this.state.event_currency_icon} occurrence_date={this.state.occurrence_date} special_note={this.state.special_note} event_tc={this.state.event_tc} tickets_selected={this.state.tickets_selected} user_email={this.state.user_email} user_phone={this.state.user_phone} main_page_change={this.main_page_handler_preview} main_page_details_change={this.main_page_handler_header}/>;
                  case 4:  return <PaymentScreen sandbox_url_creator={this.state.sandbox_url_creator} name_of_class={name_of_payment_screen_class} access_token="0" ticket_token={this.state.ticket_token} order_id={this.state.order_id} total_amount={this.state.total_amount} event_currency={this.state.event_currency} event_currency_icon={this.state.event_currency_icon} user_email={this.state.user_email} user_phone={this.state.user_phone} main_page_change_free={this.main_page_handler_free_confirmation} main_page_change_simpl={this.main_page_handler_simpl} />;
                  default: return "";
                }
            })()}
          </div>
        );
      }else{
        return (
          <div key="second_full_page" id="second_full_page" className="full_page">
            {(() => {
                switch (this.state.page_num) {
                  case 6:  return <ConfirmationScreen sandbox_url_creator={this.state.sandbox_url_creator} name_of_class={name_of_confirmation_class} access_token="0" order_id={this.state.order_id} paypal_id={this.state.paypal_id} />;
                  default: return "";
                }
            })()}
          </div>
        );
      }
    }else{
      return(<div>Please Wait...</div>);
    }
  }

}

//Removing these sections right now to complete payment screen, add them later above instead of payment screen at top

export default FullAreaCheckout;


// WEBPACK FOOTER //
// ./src/desktop/desktopControllerPage.js